import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, money } from "@/lib/api";

const fmt = (x) => (x ? String(x).replace(".", ",") : "");

export const ThPercueInput = ({ r, onSaved, testId, suggestion }) => {
  const [v, setV] = useState(fmt(r.th_percue));
  useEffect(() => { setV(fmt(r.th_percue)); }, [r.th_percue]);
  const save = async (val) => {
    const n = Number(String(val).replace(/\s/g, "").replace(",", ".") || 0);
    if (Number.isNaN(n) || n < 0) { toast.error("Montant invalide"); setV(fmt(r.th_percue)); return; }
    if (Math.round(n * 100) === Math.round((r.th_percue || 0) * 100)) { setV(fmt(r.th_percue)); return; }
    try { await api.put(`/reservations/${r.id}/th-percue`, { montant: n }); toast.success(`Taxe de séjour perçue : ${money(n)} (${r.code})`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); setV(fmt(r.th_percue)); }
  };
  return (
    <span className="inline-flex items-center gap-2">
      <input value={v} onChange={(e) => setV(e.target.value)} onBlur={() => save(v)} onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget.blur(); } }}
        inputMode="decimal" placeholder="0,00" title="Taxe de séjour perçue par Booking auprès du voyageur"
        className="h-7 w-20 rounded border border-slate-200 bg-white px-1.5 text-right text-xs tabular outline-none focus:ring-2 focus:ring-emerald-300" data-testid={testId} />
      {suggestion != null && (
        <Button type="button" size="sm" variant="outline" className="h-7 px-2 text-[11px]" onClick={() => save(suggestion.toFixed(2))} data-testid={`${testId}-suggestion`}>
          3,5 % du loyer ({money(suggestion)})
        </Button>
      )}
    </span>
  );
};
